export default __webpack_public_path__ + "static/media/phima.9f555086.png";